import { CALL_API } from 'redux-api-middleware'
import { containsRole } from '../utils/helpers'
import { APP_CONTEXT_PARTNERS_RECEIVE, PREPOPULATE_PARTNERS } from './appContext'
import slugid from 'slugid'

export const AUTH_PROFILE_REQUEST = 'authProfile/PROFILE_REQUEST'
export const AUTH_PROFILE_RECEIVE = 'authProfile/PROFILE_RECEIVE'
export const AUTH_PROFILE_FAILURE = 'authProfile/PROFILE_FAILURE'
export const CHANGE_PASSWORD_REQUEST = 'changePassword/REQUEST'
export const CHANGE_PASSWORD_RECEIVE = 'changePassword/RECEIVE'
export const CHANGE_PASSWORD_FAILURE = 'changePassword/FAILURE'
export const EXTERNAL_AUTH_PROFILE_REQUEST = 'authProfile/EXTERNAL_AUTH_PROFILE_REQUEST'
export const EXTERNAL_AUTH_PROFILE_RECEIVE = 'authProfile/EXTERNAL_AUTH_PROFILE_RECEIVE'
export const EXTERNAL_AUTH_PROFILE_FAILURE = 'authProfile/EXTERNAL_AUTH_PROFILE_FAILURE'
export const LOGIN_REDIRECT_REQUEST = 'loginRedirect/REQUEST'
export const LOGIN_REDIRECT_RECEIVE = 'loginRedirect/RECEIVE'
export const LOGIN_REDIRECT_FAILURE = 'loginRedirect/FAILURE'
export const LOGIN_REQUEST = 'login/REQUEST'
export const LOGIN_RECEIVE = 'login/RECEIVE'
export const LOGIN_FAILURE = 'login/FAILURE'
export const LOG_OUT_REQUEST = 'logOut/REQUEST'
export const LOG_OUT_RECEIVE = 'logOut/RECEIVE'
export const LOG_OUT_FAILURE = 'logOut/FAILURE'
export const FORGOT_PASSWORD_RESET_REQUEST = 'forgotPassword/REQUEST'
export const FORGOT_PASSWORD_RESET_RECEIVE = 'forgotPassword/RECEIVE'
export const FORGOT_PASSWORD_RESET_FAILURE = 'forgotPassword/FAILURE'
export const SHOW_PROFILE_MENU = 'showProfileMenu'
export const SET_IS_DONE_AUTHORIZING = 'isDoneAuthorizing'
export const SET_MENU_ANCHOR_ELEMENT = 'setMenuAnchorElement'
export const SET_SECURITY_QUESTIONS_REQUEST = 'securityQuestions/SET_SECURITY_QUESTIONS_REQUEST'
export const SET_SECURITY_QUESTIONS_RECEIVE = 'securityQuestions/SET_SECURITY_QUESTIONS_RECEIVE'
export const SET_SECURITY_QUESTIONS_FAILURE = 'securityQuestions/SET_SECURITY_QUESTIONS_FAILURE'
export const TOKEN_REQUEST = 'authProfile/TOKEN_REQUEST'
export const TOKEN_RECEIVE = 'authProfile/TOKEN_RECEIVE'
export const TOKEN_FAILURE = 'authProfile/TOKEN_FAILURE'
export const VERIFY_SECURITY_QUESTION_REQUEST = 'securityQuestions/VERIFY_SECURITY_QUESTION_REQUEST'
export const VERIFY_SECURITY_QUESTION_RECEIVE = 'securityQuestions/VERIFY_SECURITY_QUESTION_RECEIVE'
export const VERIFY_SECURITY_QUESTION_FAILURE = 'securityQuestions/VERIFY_SECURITY_QUESTION_FAILURE'
export const VERIFY_USER_REQUEST = 'securityQuestions/VERIFY_USER_REQUEST'
export const VERIFY_USER_RECEIVE = 'securityQuestions/VERIFY_USER_RECEIVE'
export const VERIFY_USER_FAILURE = 'securityQuestions/VERIFY_USER_FAILURE'


const initialState = {
  applicationIds: [],
  isDoneAuthorizing: false,
  email: '',
  firstName: '',
  groups: [],
  lastName: '',
  paAdmin: [],
  partners: [],
  userPartners: [],
  passedSecurityChallenge: false,
  recoveryQuestion: '',
  userId: '',
  userMemberships: [],
  userRoles: [],
  showProfileMenu: false,
  menuAnchorElement: {},
  whitelist: []
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case APP_CONTEXT_PARTNERS_RECEIVE:
      return {
        ...state,
        partners: action.payload.data.items
      }
    case AUTH_PROFILE_RECEIVE:
      const userInfo = action.payload
      if (isNordEmployee(userInfo)) {
        let userMemberships = []
        if (userInfo.groups_whitelist.length > 0) {
          // If it is a nord employee, they are either System or App admin, all others will be blocked by Okta.
          userMemberships = userInfo.groups_whitelist.includes('TECH_NAUTH-ADMIN') ? ['System-Admin'] : ['Application-Admin']
        }
        return {
          ...state,
          isDoneAuthorizing: true,
          email: userInfo['email'],
          firstName: userInfo['first_name'],
          lastName: userInfo['last_name'],
          paAdmin: userInfo['pa_admin'],
          partners: [],
          recoveryQuestion: '',
          userMemberships,
          userRoles: [],
          whitelist: userInfo['groups_whitelist']
        }
      } else {
        const item = action.payload
        const groups = item.groups || []
        const profile = item.profile
        let isPartnerAccessAdmin = false
        let partners = []
        let userPartners = []
        groups.filter((group) => {
          userPartners.push(group.partner)
          if (containsRole(group.roles, 'PartnerAccessAdmin')) {
            isPartnerAccessAdmin = true
            partners.push(group.partner)
            return true
          } else {
            return false
          }
        })
        if (partners.length > 0) {
          window.localStorage.setItem('partners', JSON.stringify(partners))
        }
        if (userPartners.length > 0) {
          window.localStorage.setItem('userPartners', JSON.stringify(userPartners))
        }
        return {
          ...state,
          applicationIds: item.applicationIds,
          email: profile ? profile.email : '',
          firstName: profile ? profile.firstName : '',
          userId: item ? item.id : '',
          groups: groups,
          lastName: profile ? profile.lastName : '',
          partners: partners,
          userPartners: userPartners,
          recoveryQuestion: profile.recoveryQuestion,
          userMemberships: [],
          userRoles: isPartnerAccessAdmin ? ['PartnerAccessAdmin'] : ['PartnerAccessUser']
        }
      }
    case AUTH_PROFILE_FAILURE:
      return {
        ...state,
        isDoneAuthorizing: true
      }
    case EXTERNAL_AUTH_PROFILE_FAILURE:
      return {
        ...state,
        isDoneAuthorizing: true
      }
    case SHOW_PROFILE_MENU:
      return {
        ...state,
        showProfileMenu: action.show
      }
    case SET_IS_DONE_AUTHORIZING: {
      return {
        ...state,
        isDoneAuthorizing: action.isDoneAuthorizing
      }
    }
    case SET_MENU_ANCHOR_ELEMENT:
      return {
        ...state,
        menuAnchorElement: action.element
      }
    case PREPOPULATE_PARTNERS:
      return {
        ...state,
        partners: action.partners
      }
    case VERIFY_SECURITY_QUESTION_RECEIVE:
      return {
        ...state,
        passedSecurityChallenge: true
      }
    case VERIFY_USER_RECEIVE: {
      return {
        ...state,
        applicationIds: action.payload.applicationIds
      }
    }
    default:
      return state
  }
}

export const setIsDoneAuthorizing = (isDoneAuthorizing) => ({ type: SET_IS_DONE_AUTHORIZING, isDoneAuthorizing })
export const setShowProfileMenu = (show) => ({ type: SHOW_PROFILE_MENU, show })
export const setMenuAnchorElement = (element) => ({ type: SET_MENU_ANCHOR_ELEMENT, element })

export function exchangeCode(params) {
  return (dispatch, getState) => {
    const { csrfToken } = getState().csrf
    return dispatch({
      [CALL_API]: {
        endpoint: () => {
          return isLocal() ? 'http://localhost:8080/token' : '/token'
        },
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token' : csrfToken
        },
        body: JSON.stringify({params}),
        types: [TOKEN_REQUEST, TOKEN_RECEIVE, TOKEN_FAILURE]
      }
    })
  }
}

export function fetchAuthProfile() {
  return {
    [CALL_API]: {
      endpoint: () => {
        return isLocal() ? 'http://localhost:8080/userinfo' :
        '/userinfo'
      },
      credentials: 'include',
      method: 'GET',
      types: [
        AUTH_PROFILE_REQUEST,
        AUTH_PROFILE_RECEIVE,
        AUTH_PROFILE_FAILURE
      ]
    }
  }
}

export const changePassword = (userId, formValues) => {
  const { currentPassword, password } = formValues
  let bodyData = {
    oldPassword: { value: currentPassword },
    newPassword: { value: password },
  }
  userId = isLocal() && userId === '' ? 'mockedUser' : userId
  return (dispatch, getState) => {
    const { csrfToken } = getState().csrf
    return dispatch({
      [CALL_API]: {
        endpoint: isLocal() ? `http://localhost:8080/api/v1/authz/users/${userId}/changepassword` :
          `/api/v1/authz/users/${userId}/changepassword`,
        method: 'PUT',
        body: JSON.stringify(bodyData),
        credentials: 'include',
        headers: { 'Content-Type': 'application/json', 'X-CSRF-Token' : csrfToken },
        types: [CHANGE_PASSWORD_REQUEST, CHANGE_PASSWORD_RECEIVE, CHANGE_PASSWORD_FAILURE]
      }
    })
  }
}

export const setSecurityQuestion = (userId, formValues) => {
  const { question, answer } = formValues
  let bodyData = {
    recovery_question: {
      question,
      answer
    }
  }
  userId = isLocal() && userId === '' ? 'mockedUser' : userId
  const authZEndpoint = `/api/v1/authz/users/${userId}/securityquestion`
  return (dispatch, getState) => {
    const { csrfToken } = getState().csrf
    return dispatch({
      [CALL_API]: {
        endpoint: isLocal() ? `http://localhost:8080${authZEndpoint}` : authZEndpoint,
        method: 'PUT',
        body: JSON.stringify(bodyData),
        credentials: 'include',
        headers: { 'Content-Type': 'application/json', 'X-CSRF-Token' : csrfToken },
        types: [SET_SECURITY_QUESTIONS_REQUEST, SET_SECURITY_QUESTIONS_RECEIVE, SET_SECURITY_QUESTIONS_FAILURE]
      }
    })
  }
}

export const forgotPassword = (userId, formValues) => {
  const { question, answer, password } = formValues
  let bodyData = {
    password: { value: password },
    recovery_question: {
      question,
      answer
    }
  }
  userId = isLocal() && userId === '' ? 'mockedUser' : userId
  const authZEndpoint = `/api/v1/authz/users/${userId}/forgotpassword`
  return (dispatch, getState) => {
    const { csrfToken } = getState().csrf
    return dispatch({
      [CALL_API]: {
        endpoint: isLocal() ? `http://localhost:8080${authZEndpoint}` : authZEndpoint,
        method: 'PUT',
        body: JSON.stringify(bodyData),
        credentials: 'include',
        headers: { 'Content-Type': 'application/json', 'X-CSRF-Token' : csrfToken },
        types: [FORGOT_PASSWORD_RESET_REQUEST, FORGOT_PASSWORD_RESET_RECEIVE, FORGOT_PASSWORD_RESET_FAILURE]
      }
    })
  }
}

// TODO: Not yet implemented--
// TODO: security challenge validation endpoint must be built in the backend
export const verifySecurityQuestionChallenge = (userId, formValues) => {
  const { question, answer } = formValues
  let bodyData = {
    question: { value: question },
    answer: { value: answer }
  }
  userId = isLocal() && userId === '' ? 'mockedUser' : userId
  const authZEndpoint = `/api/v1/authz/users/${userId}/verifysecurityquestion`
  return (dispatch, getState) => {
    const { csrfToken } = getState().csrf
    return dispatch({
      [CALL_API]: {
        endpoint: isLocal() ? `http://localhost:8080${authZEndpoint}` : 'not yet implemented',
        method: 'PUT',
        body: JSON.stringify(bodyData),
        credentials: 'include',
        headers: { 'Content-Type': 'application/json', 'X-CSRF-Token' : csrfToken },
        types: [VERIFY_SECURITY_QUESTION_REQUEST, VERIFY_SECURITY_QUESTION_RECEIVE, VERIFY_SECURITY_QUESTION_FAILURE]
      }
    })
  }
}

export function login(options) {
  const { shouldForceReauthentication } = options
  const state = slugid.nice()
  sessionStorage.setItem('localState', state)
  return {
    [CALL_API]: {
      endpoint: () => {
        const query = window.location.search || ''
        return isLocal() ? `http://localhost:8080/login${query}` :
        '/login'
      },
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        state,
        shouldForceReauthentication
      }),
      types: [
        LOGIN_REQUEST,
        {
          type: LOGIN_RECEIVE,
          payload: (action, state, res) => {
            res.json().then(json => {
              window.location = json.url
            })
          }
        },
        LOGIN_FAILURE
      ]
    }
  }
}

export function logout() {
  return (dispatch, getState) => {
    const { csrfToken } = getState().csrf
    return dispatch({
      [CALL_API]: {
        endpoint: isLocal() ? 'http://localhost:8080/logout' : '/logout',
        method: 'POST',
        credentials: 'include',
        headers: {
          'X-CSRF-Token' : csrfToken
        },
        types: [LOG_OUT_REQUEST, LOG_OUT_RECEIVE, LOG_OUT_FAILURE]
      }
    })
  }
}

export const verifyExternalUserAccess = (userId) => {
  userId = isLocal() && userId === '' ? 'mockedUser' : userId
  const authZEndpoint = `/api/v1/authz/users/${userId}/info`
  return (dispatch, getState) => {
    const { csrfToken } = getState().csrf
    return dispatch({
      [CALL_API]: {
        endpoint: isLocal() ? `http://localhost:8080${authZEndpoint}` : authZEndpoint,
        method: 'GET',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json', 'X-CSRF-Token' : csrfToken },
        types: [VERIFY_USER_REQUEST, VERIFY_USER_RECEIVE, VERIFY_USER_FAILURE]
      }
    })
  }
}

function isLocal() {
  return process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test'
}

// Takes in the 'data' property of a userinfo JSON response
// Returns true if user is a Nordstrom internal employee; false otherwise
export function isNordEmployee(userInfo) {
  return userInfo && userInfo['groups_whitelist'] && userInfo['groups_whitelist'].length > 0
}

export default reducer
